import React from "react";
import Header from "../../components/Header";
import Summary from "../../components/Summary";
import Title from "../../components/Title";

const index = () => {
  return (
    <>
      <Header />
      <Title />
      <Summary />
    </>
  );
};

export default index;
